import SpinePreview from 'game/scenes/SpinePreview';
import Welcome from 'game/scenes/Welcome';
import Scenario from 'game/scenes/Scenario';
import Interaction from 'game/scenes/Interaction';
import Landing from 'game/scenes/Landing';

export const KEYS = {
  SpinePreview: 'SpinePreview',
  Welcome: 'Welcome',
  Scenario: 'Scenario',
  Interaction: 'Interaction',
  Landing: 'Landing',
};

export const SCENE_MAP = [
  { key: KEYS.Landing, state: Landing },
  { key: KEYS.SpinePreview, state: SpinePreview },
  { key: KEYS.Welcome, state: Welcome },
  { key: KEYS.Scenario, state: Scenario },
  { key: KEYS.Interaction, state: Interaction },
];
